import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "me-7 mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "media/avatars/blank.png",
      alt: "image"
    }),
    /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" })
  ])
], -1)
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "d-flex align-items-center mb-2" }
const _hoisted_9 = { class: "text-gray-800 fs-2 fw-bolder me-1" }
const _hoisted_10 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_11 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_12 = { class: "d-flex align-items-center text-gray-400 me-5 mb-2" }
const _hoisted_13 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_14 = { class: "d-flex align-items-center text-gray-400 me-5 mb-2" }
const _hoisted_15 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_18 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_19 = { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }
const _hoisted_20 = { class: "d-flex justify-content-between w-100 mt-auto mb-2" }
const _hoisted_21 = { class: "fw-bold fs-6 text-gray-400" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-6" }, "50%", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "h-5px mx-3 w-100 bg-light mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "bg-success rounded h-5px",
    role: "progressbar",
    style: {"width":"50%"},
    "aria-valuenow": "50",
    "aria-valuemin": "0",
    "aria-valuemax": "100"
  })
], -1)
const _hoisted_24 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder" }
const _hoisted_25 = { class: "nav-item mt-2" }
const _hoisted_26 = { class: "nav-item mt-2" }
const _hoisted_27 = { class: "nav-item mt-2" }
const _hoisted_28 = {
  key: 0,
  class: "nav-item mt-2"
}
const _hoisted_29 = {
  key: 1,
  class: "nav-item mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.formData.firstname) + " " + _toDisplayString(_ctx.formData.lastname), 1),
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("p", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg\n                      " })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.t("user.developer")), 1)
                  ]),
                  _createElementVNode("p", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.formData.address) + " " + _toDisplayString(_ctx.formData.postcode) + " " + _toDisplayString(_ctx.formData.city) + " " + _toDisplayString(_ctx.formData.country_iso_2), 1)
                  ]),
                  _createElementVNode("a", {
                    href: 'mailto:' + _ctx.formData.email,
                    class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
                  }, [
                    _createElementVNode("span", _hoisted_17, [
                      _createVNode(_component_inline_svg, { src: "\n                        media/icons/duotune/communication/com011.svg\n                      " })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.formData.email), 1)
                  ], 8, _hoisted_16)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.t("user.profileCompletion")), 1),
                  _hoisted_22
                ]),
                _hoisted_23
              ])
            ])
          ])
        ]),
        _createElementVNode("ul", _hoisted_24, [
          _createElementVNode("li", _hoisted_25, [
            _createVNode(_component_router_link, {
              to: _ctx.getUserRoute(_ctx.$route) + _ctx.$route.params.id + '/overview',
              class: "nav-link text-active-primary ms-0 me-10 py-5",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("user.overview")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_26, [
            _createVNode(_component_router_link, {
              to: _ctx.getUserRoute(_ctx.$route) + _ctx.$route.params.id + '/settings',
              class: "nav-link text-active-primary ms-0 me-10 py-5",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("user.settings")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("li", _hoisted_27, [
            _createVNode(_component_router_link, {
              to: _ctx.getUserRoute(_ctx.$route) + _ctx.$route.params.id + '/permission',
              class: "nav-link text-active-primary ms-0 me-10 py-5",
              "active-class": "active"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("user.permission")), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          (!_ctx.getUserRouteType(_ctx.$route))
            ? (_openBlock(), _createElementBlock("li", _hoisted_28, [
                _createVNode(_component_router_link, {
                  to: _ctx.getUserRoute(_ctx.$route) + _ctx.$route.params.id + '/managed-customers',
                  class: "nav-link text-active-primary ms-0 me-10 py-5",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("user.managedCustomers")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.getUserRouteType(_ctx.$route))
            ? (_openBlock(), _createElementBlock("li", _hoisted_29, [
                _createVNode(_component_router_link, {
                  to: _ctx.getUserRoute(_ctx.$route) + _ctx.$route.params.id + '/managed-merchants',
                  class: "nav-link text-active-primary ms-0 me-10 py-5",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.t("user.managedMerchants")), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}